module.exports = __webpack_public_path__ + "static/media/sensors.e78b2b5f.svg";